import system from 'system-components'

// TODO -- Make is: 'p'
const BodyText = system(
  {
    color: 'gray.0',
    lineHeight: 1.4,
    fontSize: [2, 3, 4],
    // fontFamily: 'sansSerif',
  },
  'space',
  'width',
  'textAlign',
  'fontWeight',
  'letterSpacing',
)

export const StaticText = system(
  {
    color: 'dark-gray',
  },
  'lineHeight',
  'fontSize',
  'space',
  'width',
  'textAlign',
  'lineHeight',
  'fontWeight',
  'letterSpacing',
)

BodyText.displayName = 'BodyText'
StaticText.displayName = 'StaticText'

export default BodyText



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Text.js